import { render, staticRenderFns } from "./filtro-procedimento-principal.vue?vue&type=template&id=06dd65ee&scoped=true"
import script from "./filtro-procedimento-principal.vue?vue&type=script&lang=ts"
export * from "./filtro-procedimento-principal.vue?vue&type=script&lang=ts"
import style0 from "./filtro-procedimento-principal.vue?vue&type=style&index=0&id=06dd65ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd65ee",
  null
  
)

export default component.exports